import React from "react";
import { BaseComponent } from "..";
import { NavLink } from "react-router-dom";
import { TopDucks, Chart, CmsBanners, CmsBannersInner } from "../Macros";
import { DashboardApi } from "../../api";
import { UserDataService } from "../../services";
import AllActions from "../AllActions";
import CommonActions from "../CommonActions";
import { PopupService } from "../Macros/Popup";
import { ActionsApi } from "../../api/Actions";
import config from "../../config";

export default class Dashboard extends BaseComponent {
  cmsPageAlias = "dashboard";
  istrackingfundcampaigndefault = this.siteSetting("istrackingfundcampaigndefault");
  isyearendactive = this.siteSetting("isyearendactive");

  // The year-end banners deep-link into the digital deposit form (21) via
  // handleNavigateToGemelDeposit, so they are an entry point to that form and have to follow the
  // same lobby switch as the tiles do. When this is false the banner chain falls through to the
  // tracking-fund campaign, exactly as it already does when the year-end campaign is switched off.
  isYearEndDepositBannerActive = () =>
    this.isyearendactive == "true" && this.isFormShownInLobby(21);
  
  constructor(props) {
    super(props);
    this.state = {
      // showGemel: sessionStorage.getItem('isGemelShowed')as unknown as boolean
      showGemel: JSON.parse(sessionStorage.getItem('isGemelShowed')?.toLowerCase())
    };

  }
  onShowTrackingFundCampaignPopup() {

    PopupService.show(
      '',
      `<div id="mail-popup">
         ${this.label("trackingfundcampaign_popup_body")}
      </div>`,
      [
        {
          caption: this.label("trackingfundcampaign_popup_confirm_btn"),
          onClick: () => {
            window.open(this.label("trackingfundcampaign_link"), "_blank");
            PopupService.hide();
          },
        },
        {
          caption: 'לא מסכים',
          onClick: () => {
            PopupService.hide();
          },
        },
      ],
      false
    );
  }

  handleNavigateToGemelDeposit(formTypeId) {
    const type = formTypeId;
    formTypeId = formTypeId == 132 ? 3 : formTypeId;
    
    ActionsApi.get(formTypeId).then(res => {
      switch (type) {
        case 21:
          window.location.href = `${config.API_URL}/forms/digital-deposit/${res}`;
          break;
        default:
          break;
      }
    });
  }

  getPalletteArray() {
    var retVal = new Array();
    for (var i = 1; i < 6; i++) {
      var str = this.siteSetting("colorpallette" + i);
      var arr = str.split(",");
      retVal.push(arr);
    }

    return retVal;
  }

  isCharts() {
    return this.state && this.state.charts?.some((c) => c.label !== "0");
  }

  componentDidMount() {



    if (this.checkKindBunner[0]?.EndOfYearInvestmentGemel == 1 && this.checkKindBunner[0]?.EndOfYearSelfEmployed == 1) {

      //  sessionStorage.setItem("isGemelShowed",JSON.stringify(!(this.state.showGemel)as unknown as boolean))
      sessionStorage.setItem("isGemelShowed", JSON.stringify(!(JSON.parse(this?.state?.showGemel))))

    }


    // if ( this.checkKindBunner[0]?.EndOfYearInvestmentGemel == 1 && this.checkKindBunner[0]?.EndOfYearSelfEmployed == 1){
    //  this.isGemelShow = 
    // }

    DashboardApi.get().then((res) => {
      var arr = this.getPalletteArray();

      for (var i = 0; i < res.charts.length; i++) {
        res.charts[i].colors = arr[i];
      }
      this.setState(res);
      sessionStorage.setItem("updatedate", res.updateDate);
    });
  }



  groupedData = this.cmsContent.banners.reduce((acc, item) => {
    // Create a new group if it doesn't exist
    if (!acc[item.group]) {
      acc[item.group] = [];
    }
    // Add the item to the group
    acc[item.group].push(item);
    return acc;
  }, {});

  group_1 = this.groupedData['1'] || [];
  group_2 = this.groupedData['2'] || [];
  group_3 = this.groupedData['3'] || [];
  group_4 = this.groupedData['4'] || [];
  group_5 = this.groupedData['5'] || [];
  group_6 = this.groupedData['6'] || [];
  group_7 = this.groupedData['7'] || [];
  group_8 = this.groupedData['8'] || [];
  group_9 = this.groupedData['9'] || [];



  checkKindBunner = JSON.parse(sessionStorage.getItem("zoomAnaliticsData"))


  render() {
    const balanceNote = this.label("dashboard_balance_note").split(" ");
    return (
      <>
        <TopDucks />

        <section className="main-dashboard">
          <div className="content-wrapper">
            <div className="main-dashboard__welcome">
              <h3 className="main-dashboard__welcome-person">
                {UserDataService.data.firstname} {UserDataService.data.lastname}
              </h3>
              <p className="main-dashboard__welcome-last-login">
                {this.state && this.state.updateDate && (
                  <span>
                    {this.label("dashboard_date")}
                    <time dateTime={this.state.updateDate} className="number">
                      {this.state.updateDate}
                    </time>
                  </span>
                )}
              </p>
            </div>
            <div className="main-dashboard__header">
              <h1 className="main-dashboard__heading">
                {this.label("dashboard_balance")}{" "}
                <span className="number">{this.state && this.state.total}</span>
              </h1>

              {(() => {
                const totalTransactionAmount = this.state?.totalTransactionAmount;
                const totalPendingStandingOrders = this.state?.totalPendingStandingOrders;
                const hasTransaction = totalTransactionAmount != null && totalTransactionAmount !== '' && totalTransactionAmount !== '0';
                const hasStandingOrder = totalPendingStandingOrders != null && totalPendingStandingOrders !== '' && totalPendingStandingOrders !== '0';

                if (hasTransaction && !hasStandingOrder) {
                  return (
                    <div className="totalTransactionAmount">
                      <div className="totalTransactionAmount__first-row">
                        <span className="amount-style">
                          לידיעתך, סך של <span className="amount-style__sum">{totalTransactionAmount} ₪ </span>נקלט בחשבונותיך לאחר מועד השיערוך.
                        </span>
                        <NavLink to="/customers/home/recent-actions" className="main-dashboard__btn">
                          לצפייה בפעולות אחרונות
                        </NavLink>
                      </div>
                    </div>
                  );
                }
                if (hasTransaction && hasStandingOrder) {
                  return (
                    <div className="totalTransactionAmount">
                      <div className="totalTransactionAmount__first-row">
                        <span className="amount-style">
                          לידיעתך, סך של <span className="amount-style__sum">{totalTransactionAmount} ₪ </span>נקלט בחשבונותיך לאחר מועד השיערוך.
                        </span>
                      </div>
                      <div className="totalTransactionAmount__btn-row">
                        <NavLink to="/customers/home/recent-actions" className="main-dashboard__btn">
                          לצפייה בפעולות אחרונות
                        </NavLink>
                      </div>
                      <div className="totalTransactionAmount__first-row">
                        <span className="amount-style">
                          בנוסף, הפקדה בהוראת קבע בסך <span className="amount-style__sum">{totalPendingStandingOrders} ₪ </span>נמצאת בתהליך קליטה{" "}
                          <br className="totalTransactionAmount__break--desktop" />
                          וצפויה להיקלט בתוך כ־5 ימי עסקים.
                        </span>
                      </div>
                    </div>
                  );
                }
                if (hasStandingOrder && !hasTransaction) {
                  return (
                    <div className="totalTransactionAmount">
                      <span className="amount-style">
                        לידיעתך, הפקדה בהוראת קבע בסך <span className="amount-style__sum">{totalPendingStandingOrders} ₪ </span>נמצאת בתהליך קליטה{" "}
                          <br className="totalTransactionAmount__break--desktop" />
                          וצפויה להיקלט בתוך כ־5 ימי עסקים.
                        </span>
                    </div>
                  );
                }
                return <span></span>;
              })()}
              {UserDataService.data.userRole === 3 && (
                <span className="main-dashboard__balance-note">
                  <span>
                    {balanceNote.map((w, i) => {
                      if (w === "{amount}")
                        return (
                          <span key={i} className="number">
                            ₪{UserDataService.data.lastActionAmount || 0}
                          </span>
                        );
                      return `${w} `;
                    })}
                  </span>
                  <br />
                  {this.label("after_last_revision_date")}
                </span>
              )}
              <p className="main-dashboard__note dispbelow992">
                {this.state && this.state.updateDate && (
                  <div className="updatetxt">
                    {this.label("dashboard_date")}
                    <time dateTime={this.state.updateDate} className="number">
                      {this.state.updateDate}
                    </time>
                  </div>
                )}
                <div>{this.label("dashboard_disc")}</div>
              </p>
            </div>
            <div
              className="main-dashboard__charts-block"
              style={{
                visibility:
                  UserDataService.data.userRole === 3 ? "hidden" : "inherit",
                height: this.isCharts() ? "auto" : "190px",
              }}
            >
              <div className="container-fluid main-dashboard__charts-container">
                <div className="row main-dashboard__charts-row">
                  {this.state &&
                    this.state?.charts?.map((x, i) => (
                      <div className="main-dashboard__charts-col" key={i}>
                        <Chart {...x} />
                      </div>
                    ))}
                </div>
              </div>
            </div>
            <div className="main-dashboard__bottom">
              <div className="container-fluid">
                <div className="row main-dashboard__bottom-row">
                  <p className="main-dashboard__note hidebelow992">
                    {this.state && this.state.updateDate && (
                      <span style={{ marginLeft: "22px" }}>
                        {this.label("dashboard_date")}
                        <time
                          dateTime={this.state.updateDate}
                          className="number"
                        >
                          {this.state.updateDate}
                        </time>
                      </span>
                    )}
                    <span>{this.label("dashboard_disc")}</span>
                  </p>

                  <div className="col-auto main-dashboard__btn-col">
                    <NavLink
                      to="/customers/home/balance"
                      className="main-dashboard__btn"
                    >
                      {this.label("dashboard_button")}
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
            {

              (this.checkKindBunner[0]?.EndOfYearInvestmentGemel == 1 && this.checkKindBunner[0]?.EndOfYearSelfEmployed != 1 && this.isYearEndDepositBannerActive()) ||
                (this.checkKindBunner[0]?.EndOfYearInvestmentGemel == 1 && this.checkKindBunner[0]?.EndOfYearSelfEmployed == 1 && (this.state.showGemel) && this.isYearEndDepositBannerActive()) ?
                <>
                  <div className="desktop-banner-view">
                    <div className="image-container">
                      <CmsBannersInner banners={this.cmsContent && this.group_3} onClick={() => this.handleNavigateToGemelDeposit(21)} />
                      <div className="number-overlay">
                        בשנת {new Date().getFullYear()} ניתן להפקיד עד {this.checkKindBunner[0]?.MaxGemelDepositAmount} ₪ בקופת גמל להשקעה,
                        <br />
                        מה שמאפשר לך להפקיד
                        עוד {this.checkKindBunner[0]?.AvailableDepositAmount} ₪ עד סוף השנה.
                      </div>
                      <button className="more-deatils-btn"
                       onClick={() => this.handleNavigateToGemelDeposit(21)}
                      >
                        <img src="/img/button_text.png" className="more-deatils-img" />
                      </button>
                    </div>
                  </div>

                  <div className="mobile-banner-view">
                    <div className="image-container">
                      <CmsBannersInner banners={this.cmsContent && this.group_5} />
                      <div className="number-overlay">
                        בשנת {new Date().getFullYear()} ניתן
                        <br />
                        להפקיד עד {this.checkKindBunner[0]?.MaxGemelDepositAmount} ₪
                        <br />
                        בקופת גמל להשקעה,
                        <br />
                        מה שמאפשר לך להפקיד
                        <br />
                        עוד {this.checkKindBunner[0]?.AvailableDepositAmount} ₪
                        <br />
                        עד סוף השנה.
                      </div>
                      <button onClick={() => this.handleNavigateToGemelDeposit(21)} className="more-deatils-btn">
                        <img src="/img/button_text.png" className="more-deatils-img" />
                      </button>
                    </div>
                  </div>
                </>

                : (this.checkKindBunner[0]?.EndOfYearSelfEmployed == 1 && this.checkKindBunner[0]?.EndOfYearInvestmentGemel != 1 && this.isYearEndDepositBannerActive()) ||
                  (this.checkKindBunner[0]?.EndOfYearInvestmentGemel == 1 && this.checkKindBunner[0]?.EndOfYearSelfEmployed == 1 && !(this.state.showGemel) && this.isYearEndDepositBannerActive()) ?

                  <>

                    <div className="desktop-banner-view">

                      <CmsBannersInner banners={this.cmsContent && this.group_2}onClick={() => this.handleNavigateToGemelDeposit(21)} />
                    </div>
                    <div className="mobile-banner-view">

                      <CmsBannersInner banners={this.cmsContent && this.group_4} onClick={() => this.handleNavigateToGemelDeposit(21)} />
                    </div>
                  </>
                  : (this.istrackingfundcampaigndefault == "true") ?
                    <>
                      <div className="desktop-banner-view">
                        <div className="image-container" style={{ cursor: 'pointer' }} onClick={()=>{this.onShowTrackingFundCampaignPopup()}}>
                          <CmsBannersInner banners={this.cmsContent && this.group_7} />
                        </div>
                      </div>
                      <div className="mobile-banner-view">
                      <div className="image-container" style={{ cursor: 'pointer' }} onClick={()=>this.onShowTrackingFundCampaignPopup()}>
                          <CmsBannersInner banners={this.cmsContent && this.group_6} />
                        </div>
                      </div>
                    </>
                    : 
                    <>
                     <div className="desktop-banner-view">
                    <div className="image-container">
                      <CmsBannersInner banners={this.cmsContent && this.group_1} />
                    </div>
                  </div>
                    <div className="mobile-banner-view">
                    <div className="image-container">
                    <CmsBannersInner banners={this.cmsContent && this.group_9} />
                    </div>
                  </div>
                  </>
            }



          </div>
          {sessionStorage.getItem("imp") !== "1" && <CommonActions />}
        </section>




        <style>
          {" "}
          {
            "@media (max-width:991px) { .desktop-banner-view{display:none !important} }"
          }{" "}
        </style>
        <style>
          {" "}
          {
            "@media (min-width:991px) { .mobile-banner-view{display:none !important} }"
          }{" "}
        </style>
        <style>
          {" "}
          {
            ".account-table-block__table-notice {display: block !important;}"
          }{" "}
        </style>
        <style>
          {" "}
          {
            '.discFont{ font-size:14px; font-family:"Almoni DL AAA", sans-serif; white-space:pre-wrap }'
          }{" "}
        </style>

        <style>
          {" "}
          {
            "@media (max-width:991px) { .dispbelow992{display:block !important; margin-top:30px; max-width:100%;font-size:10px} time{font-size:10px !important} }"
          }{" "}
        </style>
        <style>
          {" "}
          {
            "@media (min-width:991px) { .dispbelow992{display:none !important} .updatetxt{ margin-left:36px} } .account-table-block__table-notice{margin-top:0px} "
          }{" "}
        </style>
        {this.label("dashboard_bottomdisc") ? (
          <pre
            style={{ fontSize: "14px" }}
            className={
              "account-table-block__table-notice content-wrapper discFont"
            }
          >
            {this.label("dashboard_bottomdisc").replace(
              "{date}",
              sessionStorage.getItem("updatedate")
            )}
          </pre>
        ) : null}
      </>
    );
  }
}
